<template>
  <div class="widget-heading pb-0 d-block">
    <div class="row">
      <div class="col-md-12 col-lg-10">
        <h4 class="d-inline-block h4" style="line-height: 1.4">
          Ubrania / środki ochrony:
        </h4>
      </div>

      <!-- Duży ekran: btn-group -->
      <div class="col-md-12 btn-group d-none d-md-flex">
        <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.terminy.ubran')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('bhp.terminy.ubran') }">Terminy wydawania ubrań
        </Link>
        <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.zestawy.asekuracyjne')"
              class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('bhp.zestawy.asekuracyjne') || isRouteActive('bhp.zestawy.asekuracyjne.elementy') }">
          Zestawy asekuracyjne
        </Link>
        <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.stan.odziezy')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('bhp.stan.odziezy') }">Stan odzieży
        </Link>
        <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.rozmiary.ubran')" class="btn btn-outline-primary"
              :class="{ 'btn-primary': isRouteActive('bhp.rozmiary.ubran') }">Rozmiary ubrań pracowników
        </Link>
      </div>

      <!-- Mały ekran: dropdown -->
      <div class="col-12 d-md-none">
        <div class="dropdown">
          <button
              class="btn btn-outline-primary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
              type="button" @click="toggleDropdown">
            {{ activeLabel }}
            <i class="bi bi-list ms-2"></i>
          </button>
          <div class="dropdown-menu w-100" :class="{ show: isDropdownOpen }">
            <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.terminy.ubran')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('bhp.terminy.ubran') }">Terminy wydawania ubrań
            </Link>
            <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.zestawy.asekuracyjne')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('bhp.zestawy.asekuracyjne')|| isRouteActive('bhp.zestawy.asekuracyjne.elementy') }">
              Zestawy asekuracyjne
            </Link>
            <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.stan.odziezy')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('bhp.stan.odziezy') }">Stan odzieży
            </Link>
            <Link v-if="hasPermission('canEditUbrania')" :href="route('bhp.rozmiary.ubran')" class="dropdown-item"
                  :class="{ 'active': isRouteActive('bhp.rozmiary.ubran') }">Rozmiary ubrań pracowników
            </Link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import {ref, computed} from "vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();
const isDropdownOpen = ref(false);

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const isRouteActive = (routeName) => {
  return route().current(routeName);
};

const labels = {
  "bhp.terminy.ubran": "Terminy wydawania ubrań",
  "bhp.zestawy.asekuracyjne": "Zestawy asekuracyjne",
  "bhp.zestawy.asekuracyjne.elementy": "Zestawy asekuracyjne",
  "bhp.stan.odziezy": "Stan odzieży",
  "bhp.rozmiary.ubran": "Rozmiary ubrań pracowników",
};

const activeLabel = computed(() => {
  const current = route().current();
  return labels[current] || "Menu";
});
</script>
